import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class assetSelectors.
 *
 */
import _ from 'underscore';
const filterNameFromEntity = entity => {
  function camelCase(str) {
    return str.substr(0, 1).toLowerCase() + str.substr(1);
  }
  let result = "".concat(camelCase(entity), "s");
  const len = entity.length;
  if (entity.substr(len - 1, len) === 'y') {
    result = "".concat(result.substr(0, len - 1), "ies");
  } else if (entity.substr(len - 1, len) === 's') {
    result = "".concat(camelCase(entity), "es");
  }
  return result;
};

/* @method - _getNode - top down approach of starting with topmost parent
 *   and if nodeList is passed in, it gets added to that list.
 */
const getNode = function getNode(object, nodeList) {
  let entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Asset';
  let idField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'id';
  let nameField = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'name';
  let entityName = entity;
  if (_.isNull(entityName)) {
    entityName = entity;
  }
  // create object node if we don't already have one.
  if (_.findIndex(nodeList, item => object[idField] === item.id) === -1) {
    if (object[idField] && _.isString(object[nameField])) {
      // keep original object data.  That gives us the ability to select
      // other attributes later on if we want.
      let newnode = _.clone(object);
      newnode = _.extend(newnode, {
        id: object[idField],
        name: object[nameField],
        entity: entityName,
        filter: filterNameFromEntity(entityName),
        nodes: []
      });

      // we did not find a job for this datum,
      // need to add it to the nodeLists.
      nodeList.push(newnode);
    }
  }
  const index = _.findIndex(nodeList, org => object[idField] === org.id);
  return nodeList[index];
};
const makeAssetTree = data => {
  const result = [];
  _.each(data, asset => {
    const category = getNode(asset, result, 'AssetCategory', 'assetCategoryID', 'assetCategoryName', true);
    if (category) {
      const assetType = getNode(asset, category.nodes, 'AssetType', 'assetTypeID', 'assetTypeName');
      if (assetType) {
        getNode(asset, assetType.nodes);
      }
    } else {
      // console.log('not adding asset because it has no category');
      // console.log(asset);
    }
  });
  return result;
};

/**
 * Logic to transform incoming AssetType options to a structure that
 * TieredSelect can understand.
 */
const makeAssetTypeTree = function makeAssetTypeTree(types) {
  let assets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let categories = [];
  // Generate asset categories from assetType.categoryName
  types.forEach(type => !categories.some(category => category.name === type.categoryName) && categories.push({
    id: type.categoryName,
    // the server expects the category name in the id field
    name: type.categoryName
  }));

  // Add all children to tier 1
  categories = categories.map(category => {
    const node = {
      id: category.id,
      name: category.name,
      entity: 'assetCategoryName'
    };

    // Add entity and nodes to each child.
    const children = types.filter(type => type.categoryName === node.name);
    node.nodes = children.map(child => {
      // add asset nodes to assetType
      const assetNodes = {};
      assets.forEach(asset => {
        if (asset.assetTypeID === child.id && !assetNodes[asset.id]) {
          assetNodes[asset.id] = asset;
        }
      });
      const typeNode = _objectSpread(_objectSpread({}, child), {}, {
        entity: 'assetType',
        nodes: Object.values(assetNodes).map(asset => _objectSpread(_objectSpread({}, asset), {}, {
          entity: 'asset',
          nodes: []
        }))
      });
      return typeNode;
    });
    return node;
  });
  return categories;
};
const makeAssetNodesForOrg = function makeAssetNodesForOrg(assets, organization, fieldToHave) {
  let fieldToNotHave = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'notARealField';
  let orgField = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  const result = [];
  assets.forEach(asset => {
    if (!asset[fieldToNotHave] && asset[fieldToHave] === organization[orgField || fieldToHave]) {
      result.push({
        id: asset.id,
        name: asset.name,
        entity: 'asset',
        nodes: []
      });
    }
  });
  return result;
};

/**
 * @method makeOrganizationTree
 *  Convert flat rows to a hiearchical representation
 *
 * example organizations:
 * [{
 *   facilityGroupAreaID: "421BD401-95CE-4A45-9E04-FAA19780EE07"
 *   facilityGroupAreaName: "Area1"
 *   facilityGroupID: "2C9C14E8-BF1B-4D05-A9EB-D8E342E800EB"
 *   facilityGroupName: "Group1"
 *   facilityID: "2DBA7570-D37A-4C98-8481-17426910DF2C"
 *   facilityName: "Fac1"
 *   id: "D9DC57CA-4EE4-4BC9-94A4-EB25D9BCE285"
 *   name: "Org 1"
 *  }]
 *
 * example assets:
 * [{
 *   facilityGroupAreaID: "687BBAC9-6900-4D8D-AAD0-2AC8DBB322D7",
 *   facilityGroupID: "DF54BA19-397E-45C9-BF78-5DC201CC2FFC",
 *   facilityID: "C3CD8464-1609-4129-802F-81A132AF4B0A",
 *   id: "7AA0DA67-E6BE-4265-AC30-D558B5435E63",
 *   name: "Asset 1",
 *   organizationID: "4BC18B6F-4FD7-4D1F-ADA0-7F6316A8BCC8",
 * }]
*/
const makeOrganizationTree = function makeOrganizationTree(organizations) {
  let assets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const orgs = {};
  organizations.forEach(row => {
    // console.log('row', row);
    // organizations
    let org = orgs[row.id];
    if (!org) {
      org = {
        id: row.id,
        name: row.name,
        entity: 'organization',
        nodes: []
      };
      orgs[row.id] = org;
    }
    const relatedAssets = assets.filter(asset => asset.organizationID === row.id);

    // facilities
    if (row.facilityID) {
      const facilities = {};
      org.nodes.forEach(facility => {
        facilities[facility.id] = facility;
      });
      let facility = facilities[row.facilityID];
      if (!facility) {
        facility = {
          id: row.facilityID,
          name: row.facilityName,
          entity: 'facility',
          nodes: []
        };
        facilities[row.facilityID] = facility;
      }
      if (row.facilityGroupID) {
        // facility groups
        const facilityGroups = {};
        facility.nodes.forEach(facilityGroup => {
          facilityGroups[facilityGroup.id] = facilityGroup;
        });
        let facilityGroup = facilityGroups[row.facilityGroupID];
        if (!facilityGroup) {
          facilityGroup = {
            id: row.facilityGroupID,
            name: row.facilityGroupName,
            entity: 'facilityGroup',
            nodes: []
          };
          facilityGroups[row.facilityGroupID] = facilityGroup;
        }
        if (row.facilityGroupAreaID) {
          // facility group areas
          const facilityGroupAreas = {};
          facilityGroup.nodes.forEach(facilityGroupArea => {
            facilityGroupAreas[facilityGroupArea.id] = facilityGroupArea;
          });
          let facilityGroupArea = facilityGroupAreas[row.facilityGroupAreaID];
          if (!facilityGroupArea) {
            facilityGroupArea = {
              id: row.facilityGroupAreaID,
              name: row.facilityGroupAreaName,
              entity: 'facilityGroupArea',
              nodes: []
            };
          }

          // add assetNodes for facilityGroupAreas
          const fgaAssetNodes = makeAssetNodesForOrg(relatedAssets, row, 'facilityGroupID', undefined);
          facilityGroupArea.nodes = facilityGroupArea.nodes.concat(fgaAssetNodes);
          facilityGroupAreas[row.facilityGroupAreaID] = facilityGroupArea;
          facilityGroups[row.facilityGroupID].nodes = Object.values(facilityGroupAreas);
        }

        // add assetNodes for facilityGroups
        const fgAssetNodes = makeAssetNodesForOrg(relatedAssets, row, 'facilityGroupID', 'facilityGroupAreaID');
        facilityGroups[row.facilityGroupID].nodes = facilityGroups[row.facilityGroupID].nodes.concat(fgAssetNodes);
        facilities[row.facilityID].nodes = Object.values(facilityGroups);
      }

      // add assetNodes for facilities
      const fAssetNodes = makeAssetNodesForOrg(relatedAssets, row, 'facilityID', 'facilityGroupID');
      facilities[row.facilityID].nodes = facilities[row.facilityID].nodes.concat(fAssetNodes);
      orgs[row.id].nodes = Object.values(facilities);
    }

    // add assetNodes for organizations
    const oAssetNodes = makeAssetNodesForOrg(relatedAssets, row, 'organizationID', 'facilityID', 'id');
    orgs[row.id].nodes = orgs[row.id].nodes.concat(oAssetNodes);
  });
  return Object.values(orgs);
};
export { makeAssetTree, makeAssetTypeTree, makeOrganizationTree };